<template>
  <div>
    <v-btn
      @click="toggleAddDialog()"
      class="info text--white"
      slot="activator"
    >Add ECS Company
    </v-btn>
    <v-dialog
      :value="addEcsCompanyDialog"
      max-width="500px"
      persistent
    >
      <v-card>
        <v-card-title
          class="pt-1 pb-1 headline grey lighten-2"
          color="primary"
          primary-title
        >
          <span class="headline">Add ECS Company</span>
          <v-spacer />
          <v-btn
            @click="toggleAddDialog()"
            fab
            small
            text
          >
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex
                md12
                sm12
                xs12
              >
                <v-text-field
                  :error-messages="addNameErrors"
                  @blur="$v.addName.$touch()"
                  @input="$v.addName.$touch()"
                  label="Name"
                  v-model="addName"
                />
              </v-flex>
              <v-flex
                md12
                sm12
                xs12
              >
                <v-text-field
                  label="Address Line One"
                  v-model="addAddressLineOne"
                />
              </v-flex>
              <v-flex
                md12
                sm12
                xs12
              >
                <v-text-field
                  label="Address Line Two"
                  v-model="addAddressLineTwo"
                />
              </v-flex>
              <v-flex
                md12
                sm12
                xs12
              >
                <v-text-field
                  label="Town"
                  v-model="addTown"
                />
              </v-flex>
              <v-flex
                md12
                sm12
                xs12
              >
                <v-text-field
                  label="Postcode"
                  v-model="addPostCode"
                />
              </v-flex>
              <v-flex
                md12
                sm12
                xs12
              >
                <v-text-field
                  label="County"
                  v-model="addCounty"
                />
              </v-flex>
              <v-flex
                md12
                sm12
                xs12
              >
                <v-autocomplete
                  :items="personnelCountryList"
                  item-text="name"
                  item-value="personnelCountryId"
                  label="Country"
                  v-model="addCountry"
                />
              </v-flex>
              <v-flex
                md12
                sm12
                xs12
              >
                <v-text-field
                  label="Fax Number"
                  v-model="addFaxNumber"
                />
              </v-flex>
              <v-flex
                md12
                sm12
                xs12
              >
                <v-text-field
                  label="Website Address"
                  v-model="addWebsiteAddress"
                />
              </v-flex>
              <v-flex
                md12
                sm12
                xs12
              >
                <v-text-field
                  label="Telephone Number"
                  v-model="addTelephoneNumber"
                />
              </v-flex>
              <v-flex
                md12
                sm12
                xs12
              >
                <v-text-field
                  label="Registration Number"
                  v-model="addRegistrationNumber"
                />
              </v-flex>
              <v-flex
                  md12
                  sm12
                  xs12
              >
                  <v-select
                      :items="[{Id: true, name: 'Yes'}, {Id: false, name: 'No'}]"
                      item-text="name"
                      item-value="Id"
                      label="Is Limited Company"
                      v-model="addIsLimitedCompany"
                  />
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn
            @click="saveNewItemAndCloseDialog"
            color="green"
            text
          >
            Save
          </v-btn>
          <v-btn
            @click="closeNewItem"
            color="red darken-1"
            text
          >
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
    import EditTableFunctions from '@/components/editTableFunctions';
import { FETCH_ECS_COMPANY_LIST, SAVE_NEW_ECS_COMPANY } from "@/store/ecs_company/actions.js";
import { RESET_DEFAULT_NEW_ECS_COMPANY, TOGGLE_NEW_ECS_COMPANY_DIALOG, UPDATE_ADD_ECS_COMPANY_FIELD } from "@/store/ecs_company/mutations.js";
import { required, } from 'vuelidate/lib/validators';
import { mapActions, mapGetters, mapMutations } from "vuex";
import { FETCH_PERSONNEL_COUNTRY_LIST } from "../../../store/personnel_country/actions";

    export default {
        name: "AddEcsCompanyDialog",

        validations: {
            addName: {required},
        },

        mixins: [
            EditTableFunctions,
        ],

        computed: {
            ...mapGetters(
            [
                "addEcsCompanyDialog",
                "personnelCountryList"
            ]
            ),

            addName: {
                get() {
                    return this.$store.state.ecsCompany.addEcsCompany.name;
                },
                set(value) {
                    this.updateNewValue('name', value);
                },
            },
            addAddressLineOne: {
                get() {
                    return this.$store.state.ecsCompany.addEcsCompany.addressLineOne;
                },
                set(value) {
                    this.updateNewValue('addressLineOne', value);
                },
            },
            addAddressLineTwo: {
                get() {
                    return this.$store.state.ecsCompany.addEcsCompany.addAddressLineTwo;
                },
                set(value) {
                    this.updateNewValue('addressLineTwo', value);
                },
            },
            addTown: {
                get() {
                    return this.$store.state.ecsCompany.addEcsCompany.town;
                },
                set(value) {
                    this.updateNewValue('town', value);
                },
            },
            addCounty: {
                get() {
                    return this.$store.state.ecsCompany.addEcsCompany.county;
                },
                set(value) {
                    this.updateNewValue('county', value);
                },
            },
            addCountry: {
                get() {
                    return this.$store.state.ecsCompany.addEcsCompany.country;
                },
                set(value) {
                    this.updateNewValue('country', value);
                },
            },
            addPostCode: {
                get() {
                    return this.$store.state.ecsCompany.addEcsCompany.postCode;
                },
                set(value) {
                    this.updateNewValue('postCode', value);
                },
            },
            addWebsiteAddress: {
                get() {
                    return this.$store.state.ecsCompany.addEcsCompany.websiteaddress;
                },
                set(value) {
                    this.updateNewValue('websiteaddress', value);
                },
            },
            addFaxNumber: {
                get() {
                    return this.$store.state.ecsCompany.addEcsCompany.faxNumber;
                },
                set(value) {
                    this.updateNewValue('faxNumber', value);
                },
            },
            addTelephoneNumber: {
                get() {
                    return this.$store.state.ecsCompany.addEcsCompany.telephoneNumber;
                },
                set(value) {
                    this.updateNewValue('telephoneNumber', value);
                },
            },
            addRegistrationNumber: {
                get() {
                    return this.$store.state.ecsCompany.addEcsCompany.registrationNumber;
                },
                set(value) {
                    this.updateNewValue('registrationNumber', value);
                },
            },
            addIsLimitedCompany: {
                get() {
                    return this.$store.state.ecsCompany.addEcsCompany.isLimitedCompany;
                },
                set(value) {
                    this.updateNewValue('isLimitedCompany', value);
                },
            },
            addNameErrors() {
                const errors = [];
                if (!this.$v.addName.$dirty) return errors;
                !this.$v.addName.required && errors.push('required.');
                return errors
            },
        },

        mounted() {
            this.resetNewItemToDefault();
            this.fetchPersonnelCountryList();
        },

        methods: {
            fetchPersonnelCountryList() {
                this.$store.dispatch(FETCH_PERSONNEL_COUNTRY_LIST);
            },

            ...mapActions({
                fetchTableList: FETCH_ECS_COMPANY_LIST,
                saveNewTableItemRecord: SAVE_NEW_ECS_COMPANY,
            }),
            //
            ...mapMutations({
                toggleAddDialog: TOGGLE_NEW_ECS_COMPANY_DIALOG,
                updateTableItemToAdd: UPDATE_ADD_ECS_COMPANY_FIELD,
                resetNewItemToDefault: RESET_DEFAULT_NEW_ECS_COMPANY,
            }),
        }
    }
</script>

<style scoped>

</style>
